import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { PaginationControlsDirective } from './pagination-controls.directive';

function coerceToBoolean(input: unknown): boolean {
  return !!input && input !== 'false';
}

@Component({
  standalone: true,
  imports: [CommonModule, PaginationControlsDirective],
  selector: 'pagination-controls',
  templateUrl: './pagination-controls.component.html',
  styleUrls: ['./pagination-controls.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PaginationControlsComponent {
  @Input() id?: string;
  @Input() maxSize = 7;
  @Input() previousLabel = 'Previous';
  @Input() nextLabel = 'Next';
  @Input() screenReaderPaginationLabel = 'Pagination';
  @Input() screenReaderPageLabel = 'page';
  @Input() screenReaderCurrentLabel = "You're on page";
  @Output() pageChange = new EventEmitter<number>();
  @Output() pageBoundsCorrection = new EventEmitter<number>();

  private _directionLinks = true;
  private _autoHide = false;
  private _responsive = false;

  @Input()
  set directionLinks(value: boolean | string) {
    this._directionLinks = coerceToBoolean(value);
  }
  get directionLinks(): boolean {
    return this._directionLinks;
  }

  @Input()
  set autoHide(value: boolean | string) {
    this._autoHide = coerceToBoolean(value);
  }
  get autoHide(): boolean {
    return this._autoHide;
  }

  @Input()
  set responsive(value: boolean | string) {
    this._responsive = coerceToBoolean(value);
  }
  get responsive(): boolean {
    return this._responsive;
  }
}
